import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll back to the top whenever the route path changes.
 *
 * The CMS uses a plain <BrowserRouter>, which never resets the scroll position on
 * navigation. In the authenticated layouts the page (window) is the scroll
 * container and the sidebar scrolls with it, so reaching a nav item low in the
 * sidebar leaves the window scrolled down. The next page then opened at that same
 * offset — on a short page (Topics, Experiments) the browser clamps it to the
 * bottom, and the admin saw empty space until they scrolled up.
 *
 * Only the pathname counts: a query-string change (filters, paging) keeps its place.
 * `scrollRef` optionally names an inner scroll container to reset as well.
 */
export default function useScrollToTopOnNavigate(scrollRef) {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (scrollRef?.current) scrollRef.current.scrollTop = 0;
  }, [pathname, scrollRef]);
}
